<template>
	<div class="homebox">
		<div class="hbbox">
			<!--<video id="videoPlay" @mouseenter="playVideo" src="../assets/images/homebanner.mp4">您的浏览器不支持 video 视屏播放。</video>-->
			<video
                   v-if="mobile!='iPhone'&& mobile!='android'"
                   id="videoPlay"
                   @mouseenter="playVideo"
                   :src="videoBanner.video"
                   :poster="videoBanner.image">您的浏览器不支持 video 视屏播放。</video>
            <video
                    v-if="mobile=='android'"
                    id="videoPlay"
                    width="100%"
                    height="100%"
                    autoplay :muted="muted_auto" loop
                    preload
                    x5-video-player-fullscreen="true"
                    x5-playsinline
                    playsinline
                    webkit-playsinline
                    :src="videoBanner.video"
                    :poster="videoBanner.image"
                    @click="removeMuted"
            ></video>
            <video
                    v-if="mobile=='iPhone'"
                    id="videoPlay"
                    width="100%"
                    height="100%"
                    autoplay :muted="muted_auto" loop
                    preload
                    webkit-playsinline
                    playsinline="true"
                    :src="videoBanner.video"
                    :poster="videoBanner.image"
                    @click="removeMuted"
            ></video>
			<!--<div class="bannernavbox">-->
				<!--<div class="hbcen">-->
					<!--<div class="hbmsg inline">-->
						<!--<router-link to="/Partner/supplier">-->
							<!--<div class="hbtt">成为供应商</div>-->
							<!--<div class="hbtteng">SUPPLIERS</div>-->
						<!--</router-link>-->
					<!--</div>-->
					<!--<div class="hbmsg inline">-->
						<!--<router-link to="/Partner/ranchisee">-->
							<!--<div class="hbtt">成为合作商</div>-->
							<!--<div class="hbtteng">RANCHISEE</div>-->
						<!--</router-link>-->
					<!--</div>-->
					<!--<div class="hbmsg inline">-->
						<!--<router-link to="/Partner/distributor">-->
							<!--<div class="hbtt">成为经销商</div>-->
							<!--<div class="hbtteng">DISTRIBUTOE</div>-->
						<!--</router-link>-->
					<!--</div>-->
				<!--</div>-->
			<!--</div>-->
		</div>
		<div>
			<div class="ntt">一九三七  值得依赖</div>
			<div class="homenav">
				<div class="inline navbox">
					<el-card class="box-card">
					  <router-link to="/AboutUs/story">
					  	<div class="nactitle">{{brandHist.title}}</div>
					  	<div class="yinname">Brand story</div>
					  	<div class="decbox">{{brandHist.brief}}</div>
					  	<div class="btn">
					  		<div>查看品牌故事</div>
					  	</div>
					  </router-link>
					</el-card>
				</div>
				<div class="inline navbox">
					<el-card class="box-card">
					  <router-link to="/AboutUs/industribute">
					  	<div class="nactitle">{{comIntro.title}}</div>
					  	<div class="yinname">Company introduction</div>
					  	<div class="decbox">{{comIntro.brief}}</div>
					  	<div class="btn">
					  		<div>查看公司介绍</div>
					  	</div>
					  </router-link>
					</el-card>
				</div>
				<div class="inline navbox">
					<el-card class="box-card">
					  <router-link to="/AboutUs/news">
					  	<div class="nactitle">新闻资讯</div>
					  	<div class="yinname">News center</div>
					  	<p class="decbox">{{news.brief}}</p>
					  	<div class="btn">
					  		<div>查看新闻资讯</div>
					  	</div>
					  </router-link>
					</el-card>
				</div>
			</div>
		</div>
		<div>
			<div class="ntt">致力于成为中国牛羊肉标准制定者和领导品牌</div>
			<div class="prohome">
				<div class="inline marginr3">
                    <img :src="bottomLeftBanner.image" @click="bannerTo(bottomLeftBanner.url)"/>
                    <!--<router-link :to="bottomLeftBanner.url"><img :src="bottomLeftBanner.image"/></router-link>-->
                </div>
				<div class="inline">
					<!--<div class="imgbthome">-->
						<!--<div class="inline marginr2">-->
                            <!--<img :src="bottomRightBanner1.image" @click="bannerTo(bottomRightBanner1.url)"/>-->
                            <!--&lt;!&ndash;<router-link :to="bottomRightBanner1.url"><img :src="bottomRightBanner1.image"/></router-link> &ndash;&gt;-->
                        <!--</div>-->
						<!--<div class="inline">-->
                            <!--<img :src="bottomRightBanner2.image" @click="bannerTo(bottomRightBanner2.url)"/>-->
                            <!--&lt;!&ndash;<router-link :to="bottomRightBanner2.url"><img :src="bottomRightBanner2.image"/></router-link>&ndash;&gt;-->
                        <!--</div>-->
					<!--</div>-->
					<div class="marginr4" style="margin-bottom: 20px;">
                        <img :src="bottomRightTopBanner.image" @click="bannerTo(bottomRightTopBanner.url)"/>
						<!--<router-link :to="bottomRightBanner3.url"></router-link>-->
					</div>
                    <div class="marginr4">
                        <img :src="bottomRightBottomBanner.image" @click="bannerTo(bottomRightBottomBanner.url)"/>
                        <!--<router-link :to="bottomRightBanner3.url"></router-link>-->
                    </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
    name: 'home',
    data () {
        return {
            msg: 'Welcome to Your home',
            mobile:"",
            muted_auto:true,
            video:null,
            videoBanner:[],
            comIntro:[],
            brandHist:[],
            news:[],
            bottomLeftBanner:[],
            bottomRightTopBanner:[],
            bottomRightBanner1:[],
            bottomRightBanner2:[],
            bottomRightBottomBanner:[],
        }
    },
    created(){
        this.mobile = navigator.appVersion.indexOf("iPhone") !== -1 ? "iPhone" : "android";
    },
    watch:{
        video(val){
            if(val){
                this.playVideo()
            }
        }
    },
    mounted() {
        this.getVideoBanner();
        this.getComIntro();
        this.getBrandHist();
        this.getNews();
        this.getBottomLeftBanner();
        this.getBottomRightTopBanner();
        this.getBottomRightBottomBanner();
//        this.getBottomRightBanner1();
//        this.getBottomRightBanner2();
//        this.getBottomRightBanner3();
        this.video = document.getElementById("videoPlay");
    },
    methods:{
        playVideo(){
            this.video.play();
        },
        removeMuted(){
            console.log("测试监听");
            this.muted_auto = false;
//            this.$forceUpdate();
        },
        getVideoBanner: async function() {
            const res = await this.$getJSON('/index/banner',{cat_id:1});
            this.videoBanner = res.data.detail;
        },
        // 加载公司简介
        getComIntro: async function () {
            const res = await this.$getJSON('/index/about');
            this.comIntro = res.data.detail;
        },
        getBrandHist: async function() {
            const res = await this.$getJSON('/index/brandHist');
            this.brandHist = res.data.detail;
        },
        getNews: async function() {
            const res = await this.$getJSON('/index/newsArticle');
            this.news = res.data.detail;
        },
        getBottomLeftBanner: async function() {
            const res = await this.$getJSON('/index/banner',{cat_id:2});
            this.bottomLeftBanner = res.data.detail;
        },
        getBottomRightTopBanner: async function() {
            const res = await this.$getJSON('/index/banner',{cat_id:11});
            this.bottomRightTopBanner = res.data.detail;
        },
//        getBottomRightBanner1: async function() {
//            const res = await this.$getJSON('/index/banner',{cat_id:3});
//            this.bottomRightBanner1 = res.data.detail;
//        },
//        getBottomRightBanner2: async function() {
//            const res = await this.$getJSON('/index/banner',{cat_id:4});
//            this.bottomRightBanner2 = res.data.detail;
//        },
        getBottomRightBottomBanner: async function() {
            const res = await this.$getJSON('/index/banner',{cat_id:5});
            this.bottomRightBottomBanner = res.data.detail;
        },
        bannerTo: function (url) {
            if(url === ""){
                return;
            } else if(url.substring(0, 1) == "/") {
                this.$router.push({path: url})
            } else {
                window.location.href = url;
            }
        }

    },
    destroy(){
      this.video.pause();
    }
  
}
</script>

<style scoped>
	@import '../assets/style/home.css'
</style>


// WEBPACK FOOTER //
// src/vew/home.vue